module.exports = __webpack_public_path__ + "static/assets/f83dc9878ce35ad83c214a2ae3848523.svg";